/**
 * Strip all undefined values from the given object.
 *
 * { a: undefined, b: 'hello' } => { b: 'hello' }
 */
export function stripObjectFromUndefined(obj: object): object {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        if (value === undefined) {
            continue;
        }

        if (
            value === null ||
            typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean' ||
            Array.isArray(value)
        ) {
            result[key] = value;
        } else {
            result[key] = stripObjectFromUndefined(value);
        }
    }

    return result;
}
